// @flow
import type { StarredItem } from "common/records/Starred.types"

export const MAX_ITEMS = 3

const getPopupItems = (items: Array<StarredItem>): Array<StarredItem> => items.slice(0, MAX_ITEMS)

export default getPopupItems
